//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import scEcharts from './index.vue';
export default {
  name: 'chartWidget',
  components: {
    scEcharts: scEcharts
  },
  inject: ['previewState'],
  props: {
    option: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    field: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    designer: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    isShowEmpty: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      myOption: {
        isNoData: true
      },
      scEchartsRefs: null
    };
  },
  watch: {
    option: {
      handler: function handler(newVal) {
        this.myOption = newVal;
      },
      deep: true
    }
  },
  mounted: function mounted() {
    this.myOption = this.option;
    console.log(this.previewState, 'previewState');
  },
  methods: {
    handleResize: function handleResize() {
      if (!this.myOption.isNoData) {
        var _this$$refs$scEcharts, _this$$refs$scEcharts2;
        (_this$$refs$scEcharts = this.$refs.scEchartsRefs) === null || _this$$refs$scEcharts === void 0 ? void 0 : (_this$$refs$scEcharts2 = _this$$refs$scEcharts.myChart) === null || _this$$refs$scEcharts2 === void 0 ? void 0 : _this$$refs$scEcharts2.resize();
      }
    },
    setSelected: function setSelected() {
      var _this$designer;
      if (this.previewState) return;
      (_this$designer = this.designer) === null || _this$designer === void 0 ? void 0 : _this$designer.setSelected(this.field);
    }
  }
};